var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { ENVIAR_COMUNICADO } from '../events';
import { buildRecipientProperties } from './utils/recipient-properties';
var HTML_TAGS = /<[^>]*>/g;
var SPACES = /\s+/g;
/**
 * Builds the `enviar_comunicado` event from the topic the API just created, so
 * the payload describes what was really sent (the empty-recipients case becomes
 * a stage recipient before reaching this point, not after).
 */
export function buildEnviarComunicadoEvent(topic, context) {
    var attachments = topic.attachments || [];
    var audience = formatAudience(topic.audience);
    var properties = __assign(__assign({ topic_id: topic._id, topic_type: topic.type }, buildRecipientProperties(topic.recipients)), { has_attachments: attachments.length > 0, attachment_count: attachments.length, allow_messages: !!topic.allowMessages, title_length: (topic.title || '').length, content_length: countCharacters(topic.content), term_id: context.termId, stage_id: context.stageId });
    if (audience) {
        properties.audience = audience;
    }
    return {
        name: ENVIAR_COMUNICADO,
        properties: properties
    };
}
function formatAudience(audience) {
    if (!audience) {
        return;
    }
    var roles = [];
    if (audience.guardian) {
        roles.push('guardian');
    }
    if (audience.student) {
        roles.push('student');
    }
    return roles.length ? roles.join('+') : undefined;
}
function countCharacters(content) {
    return (content || '')
        .replace(HTML_TAGS, ' ')
        .replace(SPACES, ' ')
        .trim()
        .length;
}
